// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cell-datetime[data-v-13d79df1]{white-space:nowrap}.cell-datetime .time[data-v-13d79df1]{color:#797777;margin-left:3px}.cell-datetime .time-sm[data-v-13d79df1]{font-size:90%}.cell-datetime .time-lg[data-v-13d79df1]{font-size:115%;font-weight:700}.cell-datetime-sm[data-v-13d79df1]{font-size:80%}", ""]);
// Exports
module.exports = exports;
